import PortfolioScreen from './PortfolioScreen';

export default PortfolioScreen;
